import { render, staticRenderFns } from "./template/index.html?vue&type=template&id=55705bae&scoped=true&external"
import script from "./Coupons.vue?vue&type=script&lang=js"
export * from "./Coupons.vue?vue&type=script&lang=js"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=55705bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55705bae",
  null
  
)

export default component.exports